import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import HaleConsoleLayout from '../../components/hale/HaleConsoleLayout';
import { useAuth } from '../../contexts/AuthContext';
import { T, FONT, PageHeading, ConsoleCard, Eyebrow, InfoRow } from './_theme';

const API = process.env.REACT_APP_BACKEND_URL;

export default function HaleProfilePage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [app, setApp] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/api/hale-marketplace/applications/me`, { withCredentials: true });
        setApp(r.data);
      } catch (e) {
        if (e?.response?.status === 401) navigate('/hale/login', { replace: true });
      }
    })();
  }, [navigate]);

  const brand = app?.draft?.brand || {};
  const founder = app?.draft?.founder || {};
  const products = app?.draft?.products || {};
  const categories = Array.isArray(products.categories) ? products.categories.join(', ') : products.categories;

  return (
    <HaleConsoleLayout>
      <PageHeading title="Profile" sub="Your company profile, contact details, and product portfolio." testid="hale-profile-title" />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <ConsoleCard data-testid="hale-profile-company">
          <Eyebrow>Company profile</Eyebrow>
          <InfoRow label="Company" value={user?.company || brand.brand_name} />
          <InfoRow label="Website" value={brand.website} />
          <InfoRow label="Country" value={brand.country} />
          <InfoRow label="Founded" value={brand.founded_year} />
        </ConsoleCard>

        <ConsoleCard data-testid="hale-profile-contact">
          <Eyebrow>Contact information</Eyebrow>
          <InfoRow label="Name" value={user?.name || founder.full_name} />
          <InfoRow label="Email" value={user?.email || founder.email} />
          <InfoRow label="Role" value={founder.role} />
        </ConsoleCard>

        <ConsoleCard className="lg:col-span-2" data-testid="hale-profile-portfolio">
          <Eyebrow>Product portfolio</Eyebrow>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8">
            <InfoRow label="Categories" value={categories} />
            <InfoRow label="Active SKUs" value={products.sku_count} />
            <InfoRow label="Retailer goals" value={products.retailer_goals} />
            <InfoRow label="Distribution" value={products.distribution} />
          </div>
          {!app && (
            <p className="mt-4 text-[12px]" style={{ color: T.MUTED, fontFamily: FONT.MONO }}>
              Portfolio details appear here once you submit a Hale application.
            </p>
          )}
        </ConsoleCard>
      </div>
    </HaleConsoleLayout>
  );
}
